import { render } from "./CampaignRikolto.vue?vue&type=template&id=689bb919&scoped=true"
import script from "./CampaignRikolto.vue?vue&type=script&lang=js"
export * from "./CampaignRikolto.vue?vue&type=script&lang=js"

import "./CampaignRikolto.vue?vue&type=style&index=0&id=689bb919&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689bb919"]])

export default __exports__